import React from 'react';
import './LoadingPage.css';
import universeLogo from '../../assets/Universe_logo_transparent.svg';

/**
 * Shared Loading Page Component
 * Issue #165: Displays a branded loading screen when content is loading
 *
 * Accessibility (WCAG 2.1 AA, EN 301 549):
 * - Uses role="status" for live region announcements
 * - aria-live="polite" for screen reader updates
 * - aria-busy="true" to indicate loading state
 * - Respects prefers-reduced-motion for animation
 * - Sufficient color contrast (AA compliant)
 *
 * @param {string} message - Optional loading message (default: "Wird geladen...")
 */
const LoadingPage = ({ message = 'Wird geladen...' }) => {
  return (
    <div
      className="loading-page"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={message}
    >
      <div className="loading-page-content">
        {/* Universe Logo */}
        <div className="loading-page-logo">
          <img
            src={universeLogo}
            alt=""
            aria-hidden="true"
            className="loading-page-logo-image"
          />
        </div>

        {/* App Name */}
        <h1 className="loading-page-title" aria-hidden="true">
          UNIVERSE
        </h1>

        {/* Tagline */}
        <p className="loading-page-tagline" aria-hidden="true">
          UPGRADE YOUR STUDENT LIFE
        </p>

        {/* Loading Spinner */}
        <div className="loading-page-spinner-container" aria-hidden="true">
          <div className="loading-page-spinner"></div>
        </div>

        {/* Screen reader text */}
        <span className="visually-hidden">
          {message}
        </span>
      </div>
    </div>
  );
};

export default LoadingPage;
